import {
  DELIVERY_DASHBOARD_TRACKING_EVENTS,
  TDeliveryDashboardButtonNavigationTab,
  TDeliveryDashboardNavigationView,
  TDeliveryDashboardOrderAssignment,
  TDeliveryDashboardOrderDetailClick
} from './index';
import { trackByEvent } from '../../../tracking/services';
import { TRACKING_DEFAULTS, COMPONENT_TYPE } from '../../../tracking/constant';


interface IOrderAssignTrackingData {
  order_action: string,
  order_alcohol: boolean,
  order_id: string,
  order_hashed: string,
  courier_vehicle?: string,
}

export interface IOrderTrackingData {
  language: string,
  country: string,
  orderData: IOrderAssignTrackingData
}

export interface INavigationOnView {
  language: string;
  component_name: 'active couriers' | 'today orders';
  list_countsTotals: string;
  list_filter:string;
  country?:string;
}

export interface IOrderDetail {
  language: string;
  country: string;
  order_action: string;
  order_alcohol: boolean;
  order_hashed: string;
  order_id: string;
}

const trackDeliveryDashboardNavigationTabButton = (
  language?: string,
  country?: string,
  dynamicActionValue?: string
) => {
  try {
    trackByEvent<TDeliveryDashboardButtonNavigationTab>(
      DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.TAB.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        component_name: DELIVERY_DASHBOARD_TRACKING_EVENTS.COMPONENT_NAME,
        component_type: DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.TAB
          .component_type as COMPONENT_TYPE,
        button_action: dynamicActionValue || '',
        country: country || '',
        language: language || '',
      }
    );
  } catch (error) {
    console.error(
      `delivery dashboard navigation tab click on ${dynamicActionValue} Error`,
      error
    );
  }
};

const trackOrderAssign = (language: string,country:string, data: IOrderAssignTrackingData) => {
  return trackByEvent<TDeliveryDashboardOrderAssignment>(DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.ASSIGNMENT.event,{
    eventCategory: '',
    component_name: DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.ASSIGNMENT.component_name,
    component_type: DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.ASSIGNMENT.component_type as COMPONENT_TYPE,
    language,
    country,
    ...data
  })
}

const trackDeliveryDashboardOnClickAssignAccordionButton = (
  data:IOrderTrackingData
) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on click accordion button`, error)
  }

}

const trackDeliveryDahsboardOnAssignOrderStart = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on assign order start`, error)
  }
}

const trackDeliveryDahsboardOnAssignOrderCancel = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on assign order start`, error)
  }
}

const trackDeliveryDahsboardOnAssignOrderComplete = (data:IOrderTrackingData) => {
    try {
      trackOrderAssign(data.language,data.country,data.orderData)
    } catch(error) {
      console.error(` delivery dashboard on assign order complete`, error)
    }
}


const trackDeliveryDashboardOnClickRemoveAccordionButton = (data:IOrderTrackingData) => {
    try {
      trackOrderAssign(data.language,data.country,data.orderData)
    } catch(error) {
      console.error(` delivery dashboard on click accordion button`, error)
    }
}

const trackDeliveryDashboardOnClickRemoveOrderStart = (data:IOrderTrackingData) => {
    try {
      trackOrderAssign(data.language,data.country,data.orderData)
    } catch(error) {
      console.error(` delivery dashboard on click accordion button`, error)
    }
}

const trackDeliveryDashboardOnClickRemoveOrderCancel = (data:IOrderTrackingData) => {
    try {
      trackOrderAssign(data.language,data.country,data.orderData)
    } catch(error) {
      console.error(` delivery dashboard on click accordion button`, error)
    }
}

const trackDeliveryDashboardOnClickRemoveOrderComplete = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on click accordion button`, error)
  }
}

const trackDeliveryDashboardOnClickReAssignOrderStart = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on click accordion button`, error)
  }
}

const trackDeliveryDashboardOnClickReAssignOrderCancel = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on click accordion button`, error)
  }
}

const trackDeliveryDashboardOnClickReAssignOrderComplete = (data:IOrderTrackingData) => {
  try {
    trackOrderAssign(data.language,data.country,data.orderData)
  } catch(error) {
    console.error(` delivery dashboard on click accordion button`, error)
  }
}


const trackDeliveryDashboardOnLoadNavigationView= (data:INavigationOnView ) => {
  try {
    trackByEvent<TDeliveryDashboardNavigationView>(
      DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.VIEW_ONLOAD.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        component_name: data.component_name,

        component_type: DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.VIEW_ONLOAD.component_type as COMPONENT_TYPE,
        country: '',
        language: data.language || '',
        list_countsTotals: data.list_countsTotals || '',
        list_filter: data.list_filter || '',
        list_action: 'view'
      }
    );
  } catch (error) {
    console.error(` delivery dashboard navigation tab on initial list view`, error)
  }
}

const trackDeliveryDashboardOrderFilterSelections = (data:INavigationOnView ) => {
  try {
    trackByEvent<TDeliveryDashboardNavigationView>(
      DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.VIEW_ONLOAD.event,
      {
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        component_type: DELIVERY_DASHBOARD_TRACKING_EVENTS.NAVIGATION.VIEW_ONLOAD.component_type as COMPONENT_TYPE,
        component_name: data.component_name,
        language: data.language || '',
        country: data.country || '',
        list_countsTotals: data.list_countsTotals.toString(),
        list_filter: data.list_filter || '',
        list_action: 'view'
      }
    );
  } catch (error) {
    console.error(` delivery dashboard tracking on order filter selection`, error)
  }
}

const trackDeliveryDashboardOrderCardClick = (data:IOrderDetail) => {
  const {country,order_alcohol,language,order_action,order_hashed,order_id} = data;
  try {
    trackByEvent<TDeliveryDashboardOrderDetailClick>(
      DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.DETAIL.event ,{
        eventCategory: TRACKING_DEFAULTS.EVENT.eventCategory,
        component_type: DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.DETAIL.component_type as COMPONENT_TYPE,
        component_name: DELIVERY_DASHBOARD_TRACKING_EVENTS.ORDERS.DETAIL.component_name,
        country,
        order_alcohol,
        language,
        order_action,
        order_hashed,
        order_id
      }
    )
    
  } catch (error) {
    console.error(` delivery dashboard tracking on order filter selection`, error)
  }
}


export { 
  trackDeliveryDashboardNavigationTabButton,
  trackDeliveryDashboardOnClickAssignAccordionButton,
  trackDeliveryDahsboardOnAssignOrderStart,
  trackDeliveryDahsboardOnAssignOrderCancel,
  trackDeliveryDahsboardOnAssignOrderComplete,
  trackDeliveryDashboardOnClickRemoveAccordionButton,
  trackDeliveryDashboardOnClickRemoveOrderStart,  
  trackDeliveryDashboardOnClickRemoveOrderCancel,
  trackDeliveryDashboardOnClickRemoveOrderComplete,
  trackDeliveryDashboardOnClickReAssignOrderStart,
  trackDeliveryDashboardOnClickReAssignOrderCancel,
  trackDeliveryDashboardOnClickReAssignOrderComplete,
  trackDeliveryDashboardOnLoadNavigationView,
  trackDeliveryDashboardOrderFilterSelections,
  trackDeliveryDashboardOrderCardClick
};
